module.exports = __webpack_public_path__ + "static/img/xdl_4.d5da031f.jpg";